/**
 * Calculating the available sidebar height after excluding some specific elements included in it
 * Afterwards, set that as the max-height in a scrollable div ( .scrollable-lesson-list )
 * Also checking if device is desktop or tablet/mobile and either sets a specific px value or recalculates the height
 */

const sidebar = document.querySelector( '.page-with-sidebar__sidebar' );
const lessonList = document.querySelector( '.scrollable-lesson-list' );

if ( lessonList ) {
	// will be used for safe distance margins
	const gutter = 40;

	const headerHeight = document.querySelector( '.site-header' ).clientHeight;

	// Check if wp adminbar exists and adjust window inner height accordingly
	let winHeight = window.innerHeight;
	if ( document.getElementById( 'wpadminbar' ) ) {
		winHeight = winHeight - gutter - 32;
	} else {
		winHeight = winHeight - gutter;
	}

	// the element in which we will adjust height
	const lessonsList = document.querySelector( '.scrollable-lesson-list' );

	const mediaQueryList = window.matchMedia( '(max-width: 992px)' );

	// getting the remaining viewport height by excluding all elements except the one that will be scrollable
	function getAvailableSidebarHeight() {
		const lessonsTitleHeight = document.querySelector( '.sidebar-book-meeting-header' ).clientHeight;

		let contactHeight = document.querySelector( '.sidebar-book-meeting-wrapper' ).clientHeight;
		contactHeight = contactHeight + gutter;

		const scrollArea = winHeight - ( headerHeight + contactHeight + lessonsTitleHeight );
		return scrollArea;
	}

	// setting height in the scrollable element
	function calculateScrollableHeight() {
		const scrollArea = getAvailableSidebarHeight();

		// Adding header height with some extra space for safety, as padding-top, to the sidebar
		sidebar.style.paddingTop = headerHeight + ( gutter / 2 ) + 'px';

		// set max-height
		lessonsList.style.maxHeight = scrollArea + 'px';
	}

	// run on pageload
	function setLessonListHeight() {
		const winWidth = window.innerWidth;
		if ( winWidth > 992 ) {
			calculateScrollableHeight();
		}

		mediaQueryList.onchange = e => {
			if ( e.matches ) {
				lessonsList.style.maxHeight = '250px';
			} else {
				calculateScrollableHeight();
			}
		};
	}

	setLessonListHeight( mediaQueryList.matches );
}
